export const ACCESS_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";
export const APP_STORE_LINK =
  "https://apps.apple.com/us/app/weelar/id1601307559";
export const PLAY_MARKET_LINK =
  "https://play.google.com/store/apps/details?id=io.weedar.app&hl=en&gl=US";
export const WEEDAR_PRODUCT_LINK = "weedar://product/";
